import { CssBaseline } from "@mui/material";

// routing
import Routes from "./routes";

// ==============================|| APP ||============================== //
import { GlobalContextProvider } from "./context/GlobalContextProvider";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from './store';

const App = () => {
  return (
    <Provider store={store}>
      <GlobalContextProvider>
        <CssBaseline />
        <BrowserRouter>
          <Routes />
        </BrowserRouter>
      </GlobalContextProvider>
    </Provider>
  );
};

export default App;
